import styles from '@/ui/header-navigation/MegaMenu.module.scss';
const Container = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};

export default Container;
